<wl-card heading="Renewal Consent Form Confirmation" *ngIf="consentPending" class="h-80vh">
  <br>
  <br>
  <br>
  <br>
  <br>
  <h3 class="text-center">Would you like to give your consent for auto-renewal for your ongoing UBI KCC loan?
  </h3>
  <div class="text-center flex flex-row justify-center">
    <wl-button (click)="confirmrenewal()">Yes</wl-button>
    <wl-button (click)="confirmreject();openDialogWithTemplateRef(myDialog)">No</wl-button>
  </div>
  <br>
  <h4 class="text-center">Note: On clicking on "Yes" you would be redirected to the Consent Form for the
    auto-renewal to fill in further details before the final submission of your loan renewal application.</h4>
  <br>
  <br>
  <br>
  <br>
  <br>

  </wl-card>

  <wl-card heading="Renewal Consent Form Confirmation" *ngIf="!consentPending" class="h-80vh">
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <h3 id="ConsentText" class="text-center"></h3>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
  
    </wl-card>




<ng-template #myDialog>
  <!-- <h2 matDialogTitle>Dialog!</h2>
  <mat-dialog-content>
    <p>The content of this dialog came from an <code>ng-template</code>! Amazing, right?</p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button matDialogClose color="primary">Dismiss</button>
  </mat-dialog-actions> -->
  <h2 class="text-center">Thank you for acknowledging</h2>
</ng-template>